/* eslint-disable */
import {execute, grable} from '../concrete'

const concreteModuleName = 'concrete'

const FarmersMoneyAreaService = {
    /**
     * 上报惠农总资金
     * @param {*} param 
     * @returns Promise 
     */
    'addFarmersTotal': function (param) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '393d8e527e134254f376e750f3f2adf5e6db4237', param)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyAreaService/addFarmersTotal`, 'json', 'POST', param);
    }, 
    /**
     * 获取其他补贴详情
     * @param {*} year 
     * @returns Promise 
     */
    'findOtherFarmersMoneyDetail': function (year) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'ad3c8306405c2c8a9e940640d07d64b1bd50c140', year)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyAreaService/${year}/findOtherFarmersMoneyDetail`, 'json', 'GET');
    }, 
    /**
     * 获取作业补贴详情
     * @param {*} year 
     * @returns Promise 
     */
    'findWorkFarmersMoneyDetail': function (year) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '30c57b8b0ede4d88f406d07003dd8f387a54742f', year)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyAreaService/${year}/findWorkFarmersMoneyDetail`, 'json', 'GET');
    }, 
    /**
     * 上报作业补贴
     * @param {*} param 
     * @returns Promise 
     */
    'addWorkSubsidy': function (param) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '2312b26ff2f74e1ce24d953b6a64694fbf10b520', param)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyAreaService/addWorkSubsidy`, 'json', 'POST', param);
    }, 
    /**
     * 编辑其他补贴回显
     * @param {*} year 
     * @returns Promise 
     */
    'editEchoOtherFarmersMoney': function (year) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'a285ac89cd185d71d017d5046aa6772c815cd2ac', year)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyAreaService/${year}/editEchoOtherFarmersMoney`, 'json', 'GET');
    }, 
    /**
     * 获取购机补贴详情
     * @param {*} year 
     * @returns Promise 
     */
    'findVehicleFarmersMoneyDetail': function (year) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'd5f394726a802d03385c25b31f87bb17df1e3513', year)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyAreaService/${year}/findVehicleFarmersMoneyDetail`, 'json', 'GET');
    }, 
    /**
     * 上报其他资金
     * @param {*} param 
     * @returns Promise 
     */
    'addOtherSubsidy': function (param) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '899da77127cb69b81dd0aaeb532ac7ae9b78a486', param)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyAreaService/addOtherSubsidy`, 'json', 'POST', param);
    }, 
    /**
     * 编辑购机补贴回显
     * @param {*} year 
     * @returns Promise 
     */
    'editEchoVehicleFarmersMoney': function (year) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'd7fac38f6b72ac27849bac7cefdec0ae7cc2b3ef', year)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyAreaService/${year}/editEchoVehicleFarmersMoney`, 'json', 'GET');
    }, 
    /**
     * 上报购机补贴
     * @param {*} param 
     * @returns Promise 
     */
    'addVehicleSubsidy': function (param) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '9febb3a968dd778450c7af85927926d91e79351b', param)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyAreaService/addVehicleSubsidy`, 'json', 'POST', param);
    }, 
    /**
     * 获取惠农资金详情
     * @param {*} year 
     * @returns Promise 
     */
    'findFarmersMoneyDetail': function (year) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'cd4fb8f7817c2736c2fdd197914af66df0240cc9', year)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyAreaService/${year}/findFarmersMoneyDetail`, 'json', 'GET');
    }, 
    /**
     * 编辑作业补贴回显
     * @param {*} year 
     * @returns Promise 
     */
    'editEchoWorkFarmersMoney': function (year) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'bcbc40e9e324c0e307e704582ec15eae6fb80d38', year)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyAreaService/${year}/editEchoWorkFarmersMoney`, 'json', 'GET');
    }, 
    /**
     * 获取惠农资金统计
     * @param {*} year 
     * @returns Promise 
     */
    'findFarmersMoneyStatistics': function (year) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '926c8d76c4e8fc9c694031bc0db163ceaa847971', year)
            : execute(concreteModuleName, `/ComZnyEopWitAgricultureApiFarmersMoneyAreaService/${year}/findFarmersMoneyStatistics`, 'json', 'GET');
    }
}

export default FarmersMoneyAreaService
